import React, { useState, useRef, useEffect } from "react";

interface Club {
  id: string;
  name: string;
  city: string;
  state: string;
  location: string;
  night: string;
  caller_cuer?: string;
  time: string;
  level: string;
  telephone: string;
  email: string;
  facebook: string;
  website: string;
  logo?: string;
  borderColor: string;
}

const clubs: Club[] = [
  {
    id: "Wa-001",
    name: "Kiwilers",
    city: "South Perth",
    state: "WA",
    location: "Community Hall, Perth",
    night: "Friday-Maintream, Monday-Plus, Tueday-Advanced",
    caller_cuer: "Richard Muir",
    time: "7:30-9:30pm",
    level: "Mainstream-Friday, Plus-Monday, Advanced-Tuesday",
    telephone: "0459 250 143",
    email: "kiwilerssdc@gmail.com",
    facebook: "https://www.facebook.com/Kiwilers",
    website: "https://kiwilerssquaredance.wixsite.com/",
    borderColor: "#F5C45C",
    logo: "",
  },
  {
    id: "WA-002",
    name: "Cloverwest",
    city: "Shenton Park",
    state: "WA",
    location: "Shenton Park Community Centre, 240 Onslow Road, Shenton Park",
    night: "Monday",
    caller_cuer: "Kevin Fitzgerald",
    time: "7:30pm",
    level: "Mainstream",
    telephone: "0413 156 192",
    email: "fitz27@bigpond.com",
    facebook: "https://facebook.com/kerrlyqs",
    website: "https://www.facebook.com/cloverwest.square.dance/about/",
    borderColor: "#F5C45C",
    logo: "",
  },
  {
    id: "WA-003",
    name: "Bunbury Square Dancers",
    city: "Eaton / Bunbury",
    state: "WA",
    location: "Eaton Family Centre, 4 Charterhouse Street, Eaton",
    night: "Monday",
    caller_cuer: "",
    time: "7-9pm",
    level: "Mainstream & Learning Plus",
    telephone: "04350 175 571",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
  {
    id: "WA-004",
    name: "Northern Stars",
    city: "Muchea",
    state: "WA",
    location: "Muchea Recreation Centre, 48 Archibald Street, Muchea",
    night: "Monday",
    caller_cuer: "Mp3 club",
    time: "7:30pm",
    level: "SSD & Mainstream",
    telephone: "0407 389 948",
    email: "northernstars.squaredance@outlook.com",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
  
  {
    id: "WA-005",
    name: "Riverside",
    city: "Bentley",
    state: "WA",
    location: "Bentley Community Centre / Bentley Hub, Nyamup Way, Bentley",
    night: "Monday",
    caller_cuer: "Mainstream",
    time: "8:00pm",
    level: "SSD & Mainstream",
    telephone: "0419 563 375",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
  {
    id: "WA-006",
    name: "Wheatbelt Squares",
    city: "Goomalling",
    state: "WA",
    location: "Goomalling Senior Citizens Centre, Cnr Quinlan & Lockyer Street, Goomalling",
    night: "Alternate Monday",
    caller_cuer: "Robert Dew",
    time: "8:00pm",
    level: "Mainstream",
    telephone: "0419 563 375",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-008",
    name: "Ups 'N' Downers",
    city: "Gosnells",
    state: "WA",
    location: "All Saints Anglican Church Hall, Cnr Hicks & Dorothy Street, Gosnells",
    night: "Tuesday",
    caller_cuer: "Keith Lethbridge",
    time: "7:30pm",
    level: "Mainstream",
    telephone: "0407 442 957",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-009",
    name: "Dolphin Dancers",
    city: "Mandurah",
    state: "WA",
    location: "Mandurah Bowling Club, 89 Allnut Street, Mandurah",
    night: "Wednesday (daytime sessions listed)",
    caller_cuer: "Natlie Scott",
    time: "1:15pm – 3:15pm",
    level: "Mainstream",
    telephone: "0411 449 344",
    email: "dolphin.dancers@outlook.com",
    facebook: "https://www.facebook.com/dolphinsquaredancers",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-0010",
    name: "Dianella Rangers",
    city: "Joondanna",
    state: "WA",
    location: "St Peter and Emmaus Church Hall, 56 Green Street, Joondanna",
    night: "Wednesday - Mainstream",
    caller_cuer: "Kevin Fitzgerald Cuer- Marilyn Van Sambeeck",
    time: "7:30pm",
    level: "Mainstream and Rounds (1I & III)",
    telephone: "+61 8 9302 4779",
    email: "",
    facebook: "https://www.facebook.com/dianellarangerssdc",
    website: "https://www.dianellarangerssdc.com/",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-0011",
    name: "Jay Gees Squares",
    city: "Bunbury",
    state: "WA",
    location: "St Augustine’s Uniting Church Hall, 119 Mangles Street, Bunbury",
    night: "Wednesday",
    caller_cuer: "Jeff Garbutt",
    time: "7:30pm-9:30pm",
    level: "Mainstream",
    telephone: "0427 935 674",
    email: "jeffgarbutt@gmail.com",
    facebook: "https://www.facebook.com/JayGeesSquares/about/",
    website: " https://jeffgarbutt.wixsite.com/jaygees",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-0012",
    name: "JoKing Cloggers",
    city: "High Wycombe / Gosnells",
    state: "WA",
    location: "Cyril Road Community Centre (Thu) / Gosnells RSL (Sat)",
    night: "Thursday & Saturday",
    caller_cuer: "",
    time: "7:00-9:oopm -(Thur), 10:30am–12:00pm (Sat)",
    level: "Clogging – all levels",
    telephone: "0417 943 640 / +61 421 589 501",
    email: "jokingcloggerswa@gmail.com",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-0013",
    name: "Allemander Squares",
    city: "Currambine",
    state: "WA",
    location: "Currambine Community Centre, 64 Delamere Avenue, Currambine",
    night: "Thursday",
    caller_cuer: "Jim Buckingham",
    time: "7:00-9:00pm",
    level: "Beginners / Mainstream / Plus (if enough dancers)",
    telephone: "0418 948 823",
    email: "jimsgr8trax2@gmail.com",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-0014",
    name: "White Gum Valley Squares",
    city: "Rossmoyne ",
    state: "WA",
    location: "Rossmoyne Bowling Club, 35 Tuscon Street, Rossmoyne",
    night: "Thursday",
    caller_cuer: "Kevin Green",
    time: "7:45pm",
    level: "Mainstream and Rounds",
    telephone: "0478 559 554",
    email: "wgvsquares@gmail.com",
    facebook: "https://www.facebook.com/profile.php?id=100066477955147",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
  {
    id: "WA-0015",
    name: "Happy Wanderers",
    city: "High Wycombe",
    state: "WA",
    location: "Cyril Road Community Centre, 58 Cyril Road, High Wycombe",
    night: "Friday",
    caller_cuer: "Kevin Kelly",
    time: "7:45pm",
    level: "7:00pm (Plus) / 8:00pm (Mainstream)",
    telephone: "0427 161 159",
    email: "happywandererssdc@gmail.com",
    facebook: "https://www.facebook.com/groups/1279808272116694",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-0016",
    name: "Swan Valley Squares",
    city: "Dayton",
    state: "WA",
    location: "Dayton Community Centre, 211 Arthur Street, Dayton",
    night: "Friday",
    caller_cuer: "Greg Fawell",
    time: "7:30pm",
    level: "Plus/Mainstream",
    telephone: "0417 912 241",
    email: "",
    facebook: "https://www.facebook.com/groups/456272654473495/",
    website: "https://swanvalleysquares.weebly.com/",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "WA-0017",
    name: "Gidgegannup Square Dance Club",
    city: "Gidgegannup",
    state: "WA",
    location: "Gidgegannup Showgrounds Hall, Old Toodyay Road, Gidgegannup",
    night: "2nd & 4th Saturday",
    caller_cuer: "",
    time: "8:00-10:00pm",
    level: "Mainstream",
    telephone: "0417 092 309",
    email: "",
    facebook: "https://www.facebook.com/groups/581177512415769",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
  {
    id: "WA-0018",
    name: "P & R Rounds",
    city: "Bassendean",
    state: "WA",
    location: "2 Kenny St, Bassendean RSL Hall/local seniors centre",
    night: "Saturday",
    caller_cuer: "Alan Eades and Marilyn Van Sambeeck",
    time: "12:00pm (Seniors) / 1:00pm (Intermediate) / 2:00pm (Beginners)",
    level: "Rounds / Intermediate / Beginners",
    telephone: "0418 926 202",
    email: "eadesa6b@bigpond.com",
    facebook: "",
    website: "",
    borderColor: "#F5C45C",
    logo: "",
  },
   {
    id: "QLD-001",
    name: "Suncoasters Square Dance Club",
    city: "Buderim",
    state: "QLD",
    location: "Sunshine Coast Square Dance Centre, Buderim, 260 Dixon Road",
    night: "1st, 3rd & 5th Saturdays",
    caller_cuer: "",
    time: "12:00pm (Seniors daytime) / 1:00pm (Intermediate) / 2:00pm (Beginners",
    level: "Basics to A",
    telephone: "0418 926 202",
    email: "",
    facebook: "https://www.facebook.com/Suncoasters",
    website: " https://www.suncoasters.com.au/",
    borderColor: "#7D0096",
    logo: "",
  },
  {
    id: "QLD-001",
    name: "Cane Country Squares",
    city: "Bundaberg",
    state: "QLD",
    location: "89 Targo Street, Rum City Silver Band Hall Bundaberg, QLD",
    night: "1st, 3rd & 5th Saturdays, Sunday-2nd & 4th each Month",
    caller_cuer: "Matthew Mills",
    time: "Friday:6:30-9:30pm, Sunday-2:00pm to 4:00pm (dayrime), Tuesday-6:00pm to 8:30pm",
    level: "Friday-Mainstream & Plus, Sunday-Advanced (A1 & A2), Tueasday-Learners' Program and full SSD ",
    telephone: "01418 479 814",
    email: "canecountrysquares@gmail.com",
    facebook: "https://www.facebook.com/canecountrysquares",
    website: "https://canecountrysquares.blogspot.com/",
    borderColor: "#7D0096",
    logo: "",
  },
  {
    id: "QLD-002",
    name: "Hervey Bay Square Dance Club",
    city: "Torquay",
    state: "QLD",
    location: "459 Boat Harbour Dr, Torquay",
    night: "Saturday, Wednesday-Mainstream",
    caller_cuer: "Matthew Mills",
    time: "9:30-11:30am (daytime), Wednesday-6.30-9.30 pm ",
    level: "Mainstream on Wednesday and Stepping Out & Mainstream (am), Saturday night-Mainstream",
    telephone: "0404 655271",
    email: "",
    facebook: "",
    website: "https://www.squaredancingherveybay.com.au/",
    borderColor: "#7D0096",
    logo: "",
  },
   {
    id: "QLD-003",
    name: "Kay's Plus",
    city: "Graceville",
    state: "QLD",
    location: "",
    night: "Sunday - Oxley 3rd of month",
    caller_cuer: "Kay Walker",
    time: "",
    level: "Wednesday - Mainstream (10:00 -11:30am -Daytime) and Plus A Level 1:10-3:00pm, ",
    telephone: "0419 717 520",
    email: "kay@kaysclubs.com",
    facebook: "",
    website: "https://www.squaredancingherveybay.com.au/",
    borderColor: "#7D0096",
    logo: "",
  },
    {
    id: "QLD-004",
    name: "Northside Promenaders",
    city: "Zillmere (Brisbane Northside)",
    state: "QLD",
    location: "30 Seeney St., Zillmere, QLD",
    night: "Thursday",
    caller_cuer: "Kay Walker",
    time: "7:00-7:30 warmup Plus/7:30pm (Mainstream)",
    level: "Plus / Mainstream",
    telephone: "0413 017 778",
    email: "northprom@gmail.com",
    facebook: "https://www.facebook.com/zillmere",
    website: "http://northsidepromenaderssdc.weebly.com/",
    borderColor: "#7D0096",
    logo: "",
  },
    {
    id: "QLD-005",
    name: "Gumdale Grandsliders",
    city: "Gumdale",
    state: "QLD",
    location: "",
    night: "",
    caller_cuer: "",
    time: "",
    level: "",
    telephone: "",
    email: "haroldliley@gmail.com",
    facebook: "",
    website: "http://gumdalegrandsliders.blogspot.com",
    borderColor: "#7D0096",
    logo: "",
  },
  {
    id: "QLD-006",
    name: "E.Z. Squares",
    city: "Caboolture",
    state: "QLD",
    location: "Senior Citizens Hall, 24 Hasking Street,Caboolture, 4510",
    night: "Sunday",
    caller_cuer: "Elaine Davis",
    time: "2:00 - 4:00pm-Daytime",
    level: "Mainstream",
    telephone: "0407679512",
    email: "rob.elaine.davis5@bigpond.com",
    facebook: "https://www.facebook.com/groups/182071119225983",
    website: "https://ezsquarescaboolture.weebly.com/",
    borderColor: "#7D0096",
    logo: "",
  },
  {
    id: "QLD-007",
    name: "Logan Square Dancers Inc.",
    city: "Crestmead",
    state: "QLD",
    location: "LoganCity square Dance Centre, 161A Magnesium Drive.Crestmead",
    night: "Thursday-Advanced (A1&A2) Workshop and Friday",
    caller_cuer: "Alan Evans",
    time: "Thursday 7:30 - 9:30pm and Friday (1st and 3rd)7:30 - 10:00pm",
    level: "Mainstream and Advanced",
    telephone: "0417 004 556",
    email: "logancitysquaredancers1@gmail.com",
    facebook: "",
    website: "https://www.logancitysquaredancers.org/",
    borderColor: "#7D0096",
    logo: "",
  },
   {
    id: "QLD-008",
    name: "Town & Country Squares",
    city: "Buderim",
    state: "QLD",
    location: "Sunshine Coast Square Dance Centre, 260 Dixon Rd, Buderim QLD ",
    night: "Saturday",
    caller_cuer: "",
    time: "7:00pm Plus or Round Dancing, 7:30 Mainstream",
    level: "Mainstream, Plus and Round Dancing",
    telephone: "0417 729 263 or 0427 135 442",
    email: "bev@suncoasters.com.au",
    facebook: "",
    website: "http://www.suncoasters.com.au/",
    borderColor: "#7D0096",
    logo: "",
  },
   {
    id: "QLD-009",
    name: "Uniting Squares",
    city: "Sherwood",
    state: "QLD",
    location: "",
    night: "Wednesday",
    caller_cuer: "Kay Walker",
    time: "",
    level: "A Level",
    telephone: "0419 717 520",
    email: "kay@kaysclubs.com",
    facebook: "",
    website: "https://www.kaysclubs.com/",
    borderColor: "#7D0096",
    logo: "",
  },
   {
    id: "QLD-010",
    name: "UpBeat Ch.a.o.s",
    city: "Deception Bay",
    state: "QLD",
    location: "Deception Bay Community Hall, 2 Raymond Tce, Deception Bay, QLD",
    night: "Monday ",
    caller_cuer: "Glenn Wilson",
    time: "6:45pm",
    level: "",
    telephone: "0413017778",
    email: "ubchaos@gmail.com",
    facebook: "",
    website: "https://upbeatchaossdc.weebly.com/",
    borderColor: "#7D0096",
    logo: "",
  },
   {
    id: "QLD-011",
    name: "Wavell Whirlaways",
    city: "Wavell Heights",
    state: "QLD",
    location: "Wonargo Scout Hall, 62 Flower Street, Northgate, Brisbane",
    night: "Wednesday Afternoons",
    caller_cuer: "",
    time: "1:30pm - 4:30pm-daytime session",
    level: "",
    telephone: "0418 724 636",
    email: "sid_leighton@hotmail.com",
    facebook: "https://www.facebook.com/wavellwhirlawaysquaredanceclub",
    website: "",
    borderColor: "#7D0096",
    logo: "",
  },
   {
    id: "SA-001",
    name: "Adelaide Outlaws Sqaure Dance Club Inc.",
    city: "West Croydon",
    state: "SA",
    location: "West Croydon & Kilkenny RSL, 19 Rosetta St, West Croydon",
    night: "Monday",
    caller_cuer: "Graham Elliott",
    time: "8:00pm",
    level: "Maintream",
    telephone: "0403 929 044",
    email: "graham@adelaideoutlaws.com",
    facebook: "https://www.facebook.com/squaredancingadelaide",
    website: "https://www.adelaideoutlaws.com/",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-002",
    name: "Adelaide Outlaws Plus",
    city: "Kilburn",
    state: "SA",
    location: "Kilburn Community Hall, Le Hunte St, Kilburn",
    night: "Wednesday",
    caller_cuer: "Graham Elliott",
    time: "8:00pm",
    level: "Plus",
    telephone: "0403 929 044",
    email: "graham@adelaideoutlaws.com",
    facebook: "https://www.facebook.com/squaredancingadelaide",
    website: "https://www.adelaideoutlaws.com/",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-003",
    name: "Diggers Delights",
    city: "Salisbury",
    state: "SA",
    location: "Salisbury RSL, 19 Park Terrace, Salisbury",
    night: "Thursday",
    caller_cuer: "Scotty Scott",
    time: "10:00am",
    level: "Beginners/Mainstream",
    telephone: "0419 864 748",
    email: "",
    facebook: "https://www.facebook.com/groups/343901843148341/",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
  {
    id: "SA-004",
    name: "Sunset Twilers",
    city: "Christies Beach",
    state: "SA",
    location: "Noarlunga District Senior Citizens Club, 9 Hunt Crescent, Christies Beach",
    night: "Tuesday - Mainstream (7pm), Thursday-Plus (8pm)",
    caller_cuer: "Les Tulloch and Anne Tulloch, Cuer",
    time: "7:00pm Tuesday, 8pm Thursday",
    level: "Mainstream and Plus",
    telephone: "0484 233 826",
    email: "lest11@bigpond.com",
    facebook: "",
    website: "https://www.sunsettwirlers.com/",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-005",
    name: "Spin the Topper's",
    city: "Pooraka",
    state: "SA",
    location: "Pooraka Farm Memorial Hall, 39 Scott Street, Pooraka 5095",
    night: "Wednesday",
    caller_cuer: "Scotty Scott",
    time: "1:30pm-daytime session",
    level: "Learners",
    telephone: "0419 864 748",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-006",
    name: "Magill Diamonds",
    city: "Magill",
    state: "SA",
    location: "Morialta Uniting Church Hall, 26 Chapel St, Magill",
    night: "Friday",
    caller_cuer: "Ivan Cooke",
    time: "7:30pm",
    level: "Mainstream",
    telephone: "0433 999 362",
    email: "",
    facebook: "https://www.facebook.com/profile.php?id=100064888622541",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-007",
    name: "Sunset Twirlers Rounds",
    city: "Cooinda",
    state: "SA",
    location: "Cooinda Neighbourhood Centre, cnr Diagonal and Sturt Roads (Behind Marion Council Offices)",
    night: "Thursday (Closed last Thursday of month)",
    caller_cuer: "Les and Anne Tulloch-Cuers",
    time: "Thursday-8:00pm, Sunday-7:00pm",
    level: "Thursday-Plus,Sunday-Rounds (Phase 2 to 4)",
    telephone: "0484 233 826",
    email: "lest11@bigpond.com",
    facebook: "",
    website: "https://www.sunsettwirlers.com/",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-008",
    name: "Dance Around SA",
    city: "Collinswood",
    state: "SA",
    location: "Chandelier Ballroom, Cassie St, Collinswood",
    night: "Sunday",
    caller_cuer: "Shirley Bates & Terry Lee-Cuers",
    time: "12 to 2pm-daytime session Phase 2 to 4, 2.30pm to 4pm Phase 4 to 6",
    level: "Phase 2 to 4 and Phase 4 to 6 ",
    telephone: " 0410 645 892 or 0418 275 409",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-009",
    name: "Steel City Squares",
    city: "Whyalla Playford",
    state: "SA",
    location: "Whyalla Uniting Church, Peters St & Barter St, Whyalla Playford SA ",
    night: "Monday",
    caller_cuer: "Graham Burgan",
    time: "7:30pm",
    level: "Learners",
    telephone: "0427 973 226",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
  {
    id: "SA-010",
    name: "Paddle Steamers",
    city: "Victor Harbor",
    state: "SA",
    location: "Victor Harbor Senior Citizens Club Inc.,Carrickalinga House, 17-19 Torrens Street, Victor Harbor",
    night: "Wednesday",
    caller_cuer: "John Casey",
    time: "7:00pm",
    level: "Mainstream/Learners",
    telephone: "0407 611 773",
    email: "",
    facebook: "https://www.facebook.com/groups/1019441312638483/",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-011",
    name: "Acey Squares",
    city: "Naracoorte",
    state: "SA",
    location: "Lutheran Church Hall, Magarey Cres, 1 Magarey Cres,Naracoorte",
    night: "Friday",
    caller_cuer: "Alan & Chris Hall",
    time: "7:30pm",
    level: "Mainstream",
    telephone: "0417 820 134 or 0410 057 955",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "SA-009",
    name: "Pine City Twirlers",
    city: "Mount Gambier",
    state: "SA",
    location: "Anglican Hall, Bay Rd, Mt Gambier",
    night: "Monday",
    caller_cuer: "Trevor",
    time: "7:30pm",
    level: "Mainstream",
    telephone: "0438 420 615",
    email: "pctwirlers@gmail.com",
    facebook: "",
    website: "",
    borderColor: "#ED174C",
    logo: "",
  },
   {
    id: "ACT-001",
    name: "Kerr-Ly-Qs Square Dance Club",
    city: "Curtin, Canberra",
    state: "ACT",
    location: "Woden Valley Uniting Church Hall, 40 Gillies St, Curtin. ACT",
    night: "Wednesday",
    caller_cuer: "Allen Kerr,Henk ten Brummelaar,Raymond Bates, Alannah Smith  ",
    time: "7:30pm-9:30pm",
    level: "Mainstream/Plus/New Dancers",
    telephone: "0459250143 or 0435017571",
    email: "kerr.ly.qs@gmail.com",
    facebook: "https://www.facebook.com/KerrLyQs",
    website: "",
    borderColor: "#FFCE00",
    logo: "",
  },
  {
    id: "ACT-004",
    name: "Daylight Diamonds",
    city: "Curtin, Canberra",
    state: "ACT",
    location: "Woden Valley Uniting Church Hall, 40 Gillies St, Curtin. ACT",
    night: "Monday (Fortnightly)-day time session",
    caller_cuer: "Allen Kerr",
    time: "2:00-4:00pm",
    level: "Plus/Advanced",
    telephone: "0459250143 or 0435017571",
    email: "kerr.ly.qs@gmail.com",
    facebook: "https://www.facebook.com/KerrLyQs",
    website: "",
    borderColor: "#FFCE00",
    logo: "",
  },
   {
    id: "ACT-003",
    name: "",
    city: "Monash, Canberra",
    state: "ACT",
    location: "Monash Retiremnet Village, Cockcroft Ave, Monash ACT",
    night: "Monday afternoon (Fortnightly)-day time session",
    caller_cuer: "Raymond Bates",
    time: "1:00-2:45pm",
    level: "Plus",
    telephone: "0422542922",
    email: "r_hbates@optusnet.com.au",
    facebook: "https://www.facebook.com/KerrLyQs",
    website: "",
    borderColor: "#FFCE00",
    logo: "",
  },
   {
    id: "ACT-002",
    name: "Canberra Square Dancers",
    city: "",
    state: "ACT",
    location: "",
    night: "",
    caller_cuer: "",
    time: "",
    level: "",
    telephone: "",
    email: "",
    facebook: "https://www.facebook.com/groups/1663802170523015/",
    website: "",
    borderColor: "#FFCE00",
    logo: "",
  },
   {
    id: "VIC-001",
    name: "Burra Squares ",
    city: "Macleod ",
    state: "VIC",
    location: "Open House Christian Involvement Centre, 67-71 Strathallan Road, Macleod. ",
    night: "Wednesday",
    caller_cuer: "Neil Wynn / Jean Wynn ",
    time: "8:00pm",
    level: "Mainstream",
    telephone: "0409 864 046",
    email: "timisi@bigpond.net.au",
    facebook: "https://www.facebook.com/p/Burra-Square-Dance-Club-100054646020605/",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
     {
    id: "VIC-003",
    name: "True Blue Squares ",
    city: "Berwick",
    state: "VIC",
    location: "Timbarra Community Centre, 26 Parkhill Dve (Timbarra Way), Berwick",
    night: "Monday - Plus, Wednesday - Mainstream",
    caller_cuer: "Tony Bowring ",
    time: "",
    level: "Mainstream, Plus",
    telephone: "0408 340 990 ",
    email: "bowring@bigpond.net.au",
    facebook: "https://www.facebook.com/profile.php?id=100089722270831",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
   {
    id: "VIC-004",
    name: "Harlequin Rounds ",
    city: "Heatherton ",
    state: "VIC",
    location: "",
    night: "Monday",
    caller_cuer: "Coral Wegmann",
    time: "",
    level: "R Ph II-IV",
    telephone: "0407 814 686 ",
    email: "",
    facebook: "https://www.facebook.com/groups/1560354400857630/",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
   {
    id: "VIC-005",
    name: "Kintyre in the West",
    city: "Werribee",
    state: "VIC",
    location: "Masonic Community Hall, 223 Watton,St, Werribee",
    night: "Monday",
    caller_cuer: "Carol Simondson",
    time: "",
    level: "Rounds-R PH II-IV+ ",
    telephone: "0400 354 445",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
   {
    id: "VIC-006",
    name: "Golden Squares",
    city: "Narre Warren",
    state: "VIC",
    location: "1 Malcolm Court (Foundation Learning Centre), Narre Warren",
    night: "Tuesday",
    caller_cuer: "Graham Jameson ",
    time: "7:30 - 9:30pm",
    level: "Mainstream",
    telephone: "0427 353 802",
    email: "",
    facebook: "https://www.facebook.com/Goldensquares/",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
   {
    id: "VIC-007",
    name: "Jaybee Square Wheelers",
    city: "Notting Hill",
    state: "VIC",
    location: "Notting Hill Hall, 386 Ferntree Gully Rd, Notting Hill",
    night: "Tuesday",
    caller_cuer: "Mike Davey/Laurina Collyer,Cuer - Pat Saunder",
    time: "8:00-10:00pm",
    level: "Mainstream, Plus & Rounds",
    telephone: "03 9590 0550 / 0403 761 051 ",
    email: "jaybeesquares@gmail.com",
    facebook: "https://www.facebook.com/Jaybeesquares",
    website: "https://www.jaybeesquares.asn.au/",
    borderColor: "#001F7E",
    logo: "",
  },
   {
    id: "VIC-008",
    name: "Whitehorse Square Dance Club",
    city: "Forest Hill ",
    state: "VIC",
    location: "Forest Hill Uniting Church, 333 Canterbury Rd, Forest HillS",
    night: "Tuesday",
    caller_cuer: "Janice Alexander",
    time: "",
    level: "Mainstream & Rounds",
    telephone: "03 9872 5399 ",
    email: "ddjdja@optusnet.com.au",
    facebook: "https://www.facebook.com/Whitehorsesquaredance",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
   {
    id: "VIC-009",
    name: "Geelong Square Dancers",
    city: "	Geelong",
    state: "VIC",
    location: "Girl Guide Hall, 33 Meyer St, Geelong ",
    night: "Tuesday",
    caller_cuer: "Darren Taylor",
    time: "",
    level: "Plus",
    telephone: "0435 091 277",
    email: "",
    facebook: "https://www.facebook.com/GeelongSquareDancers",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
   {
    id: "VIC-010",
    name: "Australian Dancers",
    city: "Moorooduc",
    state: "VIC",
    location: "Moorooduc Hall, Cnr Derril Road & Bentons Rd, Moorooduc",
    night: "Saturday-Rounds&Mainstream(7:00-10:00pm), Wednesday-Plus (7:30-9:30pm), Sunday-Learners&Mainstream (6:30-9:45pm) ",
    caller_cuer: "Jayden Frigo",
    time: "7:00-10:00pm Saturday, 7:30-9:30pm Wednesday, 6:30-0:45pm Sunday",
    level: "Rounds, Beginners, Mainstream ",
    telephone: " 0400 878 259",
    email: "jadenfrigo@gmail.com",
    facebook: "https://www.facebook.com/groups/229732563336239",
    website: "https://jadenfrigo.wixsite.com/australianadancers",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-011",
    name: "Crossroads",
    city: "Hoppers Crossing",
    state: "VIC",
    location: "Quantun Binnah Community Centre, 61 Thames Blvd, Hoppers Crossing",
    night: "Wednesday",
    caller_cuer: "Howard Cockburn",
    time: "7:30-9:30pm",
    level: "Mainstream and Plus",
    telephone: "0417 025 828",
    email: "howard.cockburn@gmail.com",
    facebook: "https://www.facebook.com/groups/103790413107844",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-012",
    name: "Southern Cross A",
    city: "Berwick",
    state: "VIC",
    location: "St Silas Anglican Church Hall, Cnr Bridport & Ferrars Sts, Albert Park",
    night: "Thursday",
    caller_cuer: "Howard Cockburn",
    time: "8:00-10:00pm",
    level: "A2",
    telephone: "0417 025 828",
    email: "howard.cockburn@gmail.com",
    facebook: "https://www.facebook.com/groups/103790413107844",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-013",
    name: "Essendon Square Dance Club",
    city: "Maribyrnong",
    state: "VIC",
    location: "Maribynong Community Centre, 9 Randell St, Maribynong",
    night: "Thursday",
    caller_cuer: "David Brown",
    time: "7:30-10:30pm",
    level: "Mainstream & Plus",
    telephone: "0400 019 866",
    email: "contact@essendonsquares.com",
    facebook: "https://www.facebook.com/profile.php?id=61582337606847",
    website: "https://www.essendonsquares.com/contact.html",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-014",
    name: "Panda High Rounds",
    city: "Boronia ",
    state: "VIC",
    location: "Boronia Progress Hall, 134 Boronia Rd, Boronia ",
    night: "Thursday",
    caller_cuer: "",
    time: "",
    level: "Rounds - R Ph IV-VI",
    telephone: "",
    email: "",
    facebook: "https://www.facebook.com/pandarounds2",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-015",
    name: "Eastern 8s",
    city: "Paynesville",
    state: "VIC",
    location: "Unting Church Hall, Cnr King St & Langford Pde, Paynesville",
    night: "",
    caller_cuer: "Bob Evans ",
    time: "",
    level: "Beginners & Mainstream",
    telephone: "0427 267 652",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-016",
    name: "Southern Cross Plus",
    city: "Albert Park",
    state: "VIC",
    location: "Senior Citizens Hall, Ferrars Place, Albert Park",
    night: "Friday",
    caller_cuer: "Howard Cockburn",
    time: "7:30-10:00pm",
    level: "Plus Fortnightly",
    telephone: "	0417 025 828 ",
    email: "howard.cockburn@gmail.com",
    facebook: "https://www.facebook.com/groups/103790413107844",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-017",
    name: "Chemistry Sets",
    city: "Deer Park",
    state: "VIC",
    location: "Deer Park Hall, 50 Station Rd, Deer Park ",
    night: "Saturday",
    caller_cuer: "Ralph Weise",
    time: "",
    level: "",
    telephone: "0419 514 147 ",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-018",
    name: "Kaleidoscope",
    city: "Heathmont",
    state: "VIC",
    location: "Heathmont Uniting Church, 89 Canterbury Rd, Heathmont",
    night: "Saturday",
    caller_cuer: "Janice Alexander ",
    time: "",
    level: "Mainstream - MS 1st & 3rd, and Plus - 5th",
    telephone: "03 9872 5399",
    email: "",
    facebook: "https://www.facebook.com/kaleidoscopesquaredance",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "VIC-019",
    name: "Country Hoedown",
    city: "Darnum",
    state: "VIC",
    location: "Darnum Memorial Hall, 4 Cropley St,Darnum ",
    night: "Sunday",
    caller_cuer: "Janet Cook ",
    time: "",
    level: "Beginners, Maintream and Rounds",
    telephone: "0419 363 614",
    email: "3810janet@gmail.com",
    facebook: "https://www.facebook.com/profile.php?id=61566655888013",
    website: "",
    borderColor: "#001F7E",
    logo: "",
  },
  {
    id: "TAS-001",
    name: "Restro Square Dance Club",
    city: "Hobart",
    state: "TAS",
    location: "7 Balamara Street, Bellerive, TAS",
    night: "Tuesday",
    caller_cuer: "Gary Petersen",
    time: "7:30 - 9:30pm",
    level: "",
    telephone: "0480 450 940",
    email: "therebelcaller@gmail.com",
    facebook: "https://www.facebook.com/profile.php?id=100075858114899",
    website: "",
    borderColor: "#006A4E",
    logo: "",
  },
  {
    id: "TAS-002",
    name: "Launceston Square Dance Club",
    city: "Launceston",
    state: "TAS",
    location: "",
    night: "Wednesday",
    caller_cuer: "Glenn MacLaren,Di Ashton,Paul Ashton,Frank Mathews,	Steve Weeks",
    time: "",
    level: "Beginners & Mainstream",
    telephone: "0438 446 535",
    email: "",
    facebook: "https://www.facebook.com/groups/2786937058237339",
    website: "",
    borderColor: "#006A4E",
    logo: "",
  },
    {
    id: "NSW-001",
    name: "Tamworth Cloverleaf Dancers",
    city: "Tamworth",
    state: "NSW",
    location: "Tamworth Baptist Church, Cnr Hillvue Rd and Duri Rd Tamworth, NSW",
    night: "Monday, 7:00pm",
    caller_cuer: "",
    time: "",
    level: "Basic and Mainstream",
    telephone: "0409 457 342",
    email: "jennysadlier@optusnet.com.au",
    facebook: "https://www.facebook.com/profile.php?id=61569132369583",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-002",
    name: "Black Stallion Square Dance Club",
    city: "Dharruk",
    state: "NSW",
    location: "West Tradies, 247 Woodstock Avenue, Dharruk, NSW",
    night: "Monday",
    caller_cuer: "Lynda Cafe",
    time: "1:30pm",
    level: "New Dancers & Basic ",
    telephone: "",
    email: "",
    facebook: "https://www.facebook.com/groups/444602964560123",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-003",
    name: "Southside Rounds",
    city: "Beecroft",
    state: "NSW",
    location: "Beecroft Uniting Church Hall, 82 Beecroft Rd, Beecroft",
    night: "Monday",
    caller_cuer: "Ed Coleman",
    time: "7:30pm",
    level: "Phase III & IV",
    telephone: "0429 900 454",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-004",
    name: "The Red Barons",
    city: "Gwyneville",
    state: "NSW",
    location: "Wollongong Senior Citizens Centre, 192 Gipps Rd, Gwyneville",
    night: "Monday",
    caller_cuer: "Barry Wonson ",
    time: "",
    level: "Mainstream/Plus",
    telephone: " 02 4229 4059",
    email: "bjwonson@gmail.com",
    facebook: "",
    website: "https://redbarons.wixsite.com/squaredance",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-005",
    name: "Shamrock Squares",
    city: "Thornton",
    state: "NSW",
    location: "Pat Hughes Community Hall, Taylor Avenue, Thornton",
    night: "Monday",
    caller_cuer: "James Harragon",
    time: "7:00pm",
    level: "Basic and Mainstream",
    telephone: "0414 938141",
    email: "jamesharragon@hotmail.com",
    facebook: "https://www.facebook.com/profile.php?id=61561685324205",
    website: "shamrocksquares.mobirisesite.com",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-006",
    name: "Hillbillies",
    city: "Pennant Hills",
    state: "NSW",
    location: "Pennant Hills/Beecroft Uniting Church Hall , Cnr Boundary Rd & Bellamy St. Pennant Hills",
    night: "Tuesday",
    caller_cuer: "Steve and Vickie Dean",
    time: "7:30pm",
    level: "Plus but caters to Mainstream.",
    telephone: "",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-007",
    name: "Central Coast Ocean Waves",
    city: "Woy Wo",
    state: "NSW",
    location: "Peninsula Community Centre 93 McMasters Road, Woy Woy",
    night: "Wednesday",
    caller_cuer: "Wendy Alexander",
    time: "6:30pm",
    level: "Beginners and Mainstream",
    telephone: "",
    email: "",
    facebook: "https://www.facebook.com/profile.php?id=61566708975323",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-008",
    name: "Newport Ocean Waves",
    city: "Warriewood",
    state: "NSW",
    location: "Ted Blackwood Community Centre, Cnr Jackson & Boondah Roads Warriewood",
    night: "Tuesday",
    caller_cuer: "Brian Hotchkies 1st and 3rd Tuesday CD the rest",
    time: "12 Noon",
    level: "",
    telephone: "",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-009",
    name: "Guys and Dolls",
    city: "Corrimal",
    state: "NSW",
    location: "Corrimal Uniting Church Hall, Cnr Russell & Underwood Streets, Corrimal",
    night: "First & Third Tuesday",
    caller_cuer: "Arthur Rae",
    time: "7:00pm",
    level: "Mainstream",
    telephone: "",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-010",
    name: "Port Squares",
    city: "Port Macquarie",
    state: "NSW",
    location: "Senior Citizens Hall, 47 Munster Street Port Macquarie",
    night: "Tuesday",
    caller_cuer: "",
    time: "7:30pm",
    level: "Basic, Mainstream & Plus",
    telephone: "Louise 0458 546880 or David 0428 235135",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-011",
    name: "Phoenix Squares",
    city: "Tamworth",
    state: "NSW",
    location: "Challenge Building 2 Eureka Place, Hillvue, Tamworth",
    night: "Tuesday",
    caller_cuer: "Malcolm Turnbull",
    time: "7:00pm",
    level: "Basic, Mainstream & Plus",
    telephone: "0437 261826, 0403 324 539",
    email: "phoenixsquarestamworth@outlook.com",
    facebook: "https://www.facebook.com/profile.php?id=61564286085918",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-012",
    name: "B-Bar-H Square Dance Club",
    city: "Kanwal",
    state: "NSW",
    location: "Wyong District Youth Centre, 91 Wallarah Rd, Kanwal",
    night: "Wednesday",
    caller_cuer: "Brian Hotchkies & Jason Nicholson",
    time: "7:30pm",
    level: "Mainstream & Plus",
    telephone: "0411 539 213",
    email: "jandlnicholson1@gmail.com",
    facebook: "https://www.facebook.com/profile.php?id=61557428903791",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-013",
    name: "Panther Squares",
    city: "Glenmore Park",
    state: "NSW",
    location: "Surveyors Creek Community Centre, Ballybunion Terrace, Glenmore Park ",
    night: "Wednesday",
    caller_cuer: "Maree Huffadine",
    time: "7:30pm",
    level: "Basic & Mainstream",
    telephone: "02 9610 2523",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-014",
    name: "Sussex/Shoalhaven",
    city: "Tomerong",
    state: "NSW",
    location: "406B Turpentine Road, Tomerong",
    night: "Wednesday",
    caller_cuer: "Jan Johnson, Cuer: Helen Hodalj",
    time: "11:00am",
    level: "Rounds & Squares – Basic, Mainstream, Plus",
    telephone: "0427 362450",
    email: "",
    facebook: "https://www.facebook.com/sussxshoalhavendance",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-016",
    name: "Tartan Promenaders",
    city: "Cardif",
    state: "NSW",
    location: "Cardiff Senior Citizens Hall, 52 Harrison Street Cardif",
    night: "Wednesday",
    caller_cuer: "James Harragon, Assistant Club Caller: Colin Burn",
    time: "6:45pm - 9:15pm",
    level: "Rounds, Mainstream & Plus",
    telephone: "0414 938 141",
    email: "Jamesharragon@hotmail.com",
    facebook: "https://www.facebook.com/profile.php?id=100078698113774",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-017",
    name: "Pelican PromenadersRound Dancing",
    city: "",
    state: "NSW",
    location: "",
    night: "Wednesday, and Fourth Sunday",
    caller_cuer: "Anne Glazier",
    time: "2:00pm",
    level: "Wednesday-Beginner Rounds,Sunday-50:50 Squares and Rounds",
    telephone: "0409 938345",
    email: "",
    facebook: "https://www.facebook.com/groups/1846689542530320",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-018",
    name: "Wandering Stars",
    city: "East Hills",
    state: "NSW",
    location: "East Hills Baptist Church,34 Forrest Road, East Hills",
    night: "Wednesday",
    caller_cuer: "David & Shirley Gibbs",
    time: "8:00pm",
    level: "Basic & Mainstream",
    telephone: "",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-019",
    name: "Carpenter & Co Square Dance Club",
    city: "Tuggerah",
    state: "NSW",
    location: "9 Anzac Road, Tuggerah",
    night: "Thursday",
    caller_cuer: "Gary Carpenter",
    time: "7:00pm",
    level: "Basic & Mainstream",
    telephone: "0429 827 793",
    email: "",
    facebook: "https://www.facebook.com/groups/1396319044004950",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-020",
    name: "Port Squares",
    city: "Port Macquarie ",
    state: "NSW",
    location: "Senior Citizens Hall 43-47 Munster Street, Port Macquarie",
    night: "Thursday",
    caller_cuer: "",
    time: "1:00pm",
    level: "Basic and Mainstream",
    telephone: "0458 546880 or 0428 235135",
    email: "",
    facebook: "https://www.facebook.com/events/port-macquarie-nsw/port-squares/1262513361676157/",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-021",
    name: "Red Barons A",
    city: "Mangerton",
    state: "NSW",
    location: "18 Brownlee Street, Mangerton",
    night: "Thursday",
    caller_cuer: "Barry Wonson",
    time: "7:30pm",
    level: "A1/A2",
    telephone: "02 4229 4059",
    email: "bjwonson@gmail.com",
    facebook: "",
    website: "https://redbarons.wixsite.com/squaredance",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-022",
    name: "Knee Deep Squares",
    city: "Jannali",
    state: "NSW",
    location: "Jannali Community Hall, Cnr Jannali Ave & Mary St, Jannali",
    night: "Friday, and Monday",
    caller_cuer: "Chris Froggatt",
    time: "7:30pm",
    level: "Monday-Basic & Mainstream, Monday-Plus",
    telephone: "0421 133 518",
    email: "kneedeepsquares@gmail.com",
    facebook: "https://www.facebook.com/profile.php?id=100057782884583",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-023",
    name: "Saintly Devils",
    city: "Tuggerah",
    state: "NSW",
    location: "Tuggerah Community Hall, Anzac Road Tuggerah",
    night: "Saturday-1st & 2nd",
    caller_cuer: "Wendy Alexander",
    time: "3:30pm",
    level: "Plus",
    telephone: "0429 444241",
    email: "ccoceanwaves@gmail.com",
    facebook: "https://www.facebook.com/profile.php?id=61566708975323",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
   {
    id: "NSW-024",
    name: "Mountain Devils Square Dance Club",
    city: "Glenbrook",
    state: "NSW",
    location: "Glenbrook Public School Hall, Woodville St,  Glenbrook",
    night: "Friday",
    caller_cuer: "David Todd",
    time: "7:00pm",
    level: "Basic/ Mainstream & Plus",
    telephone: "0411 888 515",
    email: "jarodd@bigpond.net.au",
    facebook: "https://www.facebook.com/MountainDevilsSquareDanceClub",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-025",
    name: "Classified A",
    city: "Berowra Heights",
    state: "NSW",
    location: "Berowra Uniting Church, 4/6 Alan Rd, Berowra Heights",
    night: "Saturday-3rd Saturday of the month",
    caller_cuer: "Brian Hotchkies ",
    time: "8:00pm",
    level: "A1 & A2",
    telephone: "0429 900 454",
    email: "",
    facebook: "",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
    {
    id: "NSW-026",
    name: "Coastal Country",
    city: "Tuggerah",
    state: "NSW",
    location: "Tuggerah Community Hall, Anzac Road, Tuggerah",
    night: "Saturday",
    caller_cuer: " Wendy Alexander",
    time: "7:30pm-Mainstream, 7:00pm-Rounds-2nd Saturday of the month",
    level: "Mainstream & Plus, Rounds-2nd Saturday of the month",
    telephone: "0429 444241",
    email: "",
    facebook: "https://www.facebook.com/groups/1106403724587555",
    website: "",
    borderColor: "#CBEDFD",
    logo: "",
  },
];

const stateButtonColors: { [key: string]: string } = {
  WA: "#F5C45C",
  SA: "#ED174C",
  NSW: "#CBEDFD",
  TAS: "#006A4E",
  ACT: "#FFCE00",
  VIC: "#001F7E",
  QLD: "#7D0096",
  ALL: "#808080",
};

const stateButtonBorders: { [key: string]: string } = {
  WA: "#000000",
  SA: "#E17000",
  VIC: "#C0C0C0",
  NSW: "#FF0000",
  QLD: "#00008B",
  ACT: "#012B88",
  TAS: "#C21E56",
  ALL: "#000000",
};

const stateButtons = Object.keys(stateButtonColors);

const App: React.FC = () => {
  const [search, setSearch] = useState("");
  const [expandedClubs, setExpandedClubs] = useState<{ [key: string]: boolean }>({});
  const [selectedState, setSelectedState] = useState("ALL");

  const toggleExpand = (id: string) => {
    setExpandedClubs((prev) => ({ ...prev, [id]: !prev[id] }));
  };

const filteredClubs = clubs.filter((club) => {
  const matchesSearch =
    club.name.toLowerCase().includes(search.toLowerCase()) ||
    club.city.toLowerCase().includes(search.toLowerCase()) ||
    club.state.toLowerCase().includes(search.toLowerCase()) ||
    club.night.toLowerCase().includes(search.toLowerCase()) ||
    (club.caller_cuer && club.caller_cuer.toLowerCase().includes(search.toLowerCase())) ||
    club.time.toLowerCase().includes(search.toLowerCase()) ||
    club.level.toLowerCase().includes(search.toLowerCase()); // ✅ fixed
  
  const matchesState = selectedState === "ALL" || club.state === selectedState;
  
  return matchesSearch && matchesState;
});

  const clubsByState: { [state: string]: Club[] } = {};
  filteredClubs.forEach((club) => {
    if (!clubsByState[club.state]) clubsByState[club.state] = [];
    clubsByState[club.state].push(club);
  });

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Australian Square Dance Clubs</h1>
      <p style={{ marginTop: "-10px" }}>© Don Barba 2025</p>

      {/* State Buttons */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "10px",
          justifyContent: "center",
          marginBottom: "20px",
          maxWidth: "360px",
          margin: "0 auto 20px",
        }}
      >
        {stateButtons.map((state) => {
          const colSpan = state === "ALL" ? 2 : 1; // last row has 2 columns
          const isActive = selectedState === state;
          const color = stateButtonColors[state];

          return (
            <button
              key={state}
              style={{
                gridColumn: `span ${colSpan}`,
                backgroundColor: color,
                border: `2px solid ${stateButtonBorders[state]}`,
                color: "#fff",
                padding: "10px",
                cursor: "pointer",
                borderRadius: "8px",
                fontWeight: "bold",
                textAlign: "center",
                transition: "all 0.3s ease",
                boxShadow: isActive ? `0 0 20px 5px ${color}` : "none", // 🌟 GLOW EFFECT
                transform: isActive ? "scale(1.05)" : "scale(1)",
              }}
              onClick={() => setSelectedState(state)}
            >
              {state}
            </button>
          );
        })}
      </div>

      {/* Search Bar */}
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <input
          type="text"
          placeholder="Search by club, city, state, night, caller, or time..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "80%",
            padding: "10px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
      </div>

      {/* Clubs Grouped by State */}
      <div>
        {Object.keys(clubsByState).map((state) => (
          <div key={state} style={{ marginBottom: "40px" }}>
            <h2
              style={{
                borderBottom: "2px solid #ccc",
                paddingBottom: "5px",
                textAlign: "center",
              }}
            >
              {state}
            </h2>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "20px",
                marginTop: "10px",
              }}
            >
              {clubsByState[state].map((club) => (
                <ClubCard
                  key={club.id}
                  club={club}
                  isExpanded={!!expandedClubs[club.id]}
                  toggleExpand={toggleExpand}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

interface ClubCardProps {
  club: Club;
  isExpanded: boolean;
  toggleExpand: (id: string) => void;
}

const ClubCard: React.FC<ClubCardProps> = ({ club, isExpanded, toggleExpand }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isExpanded ? contentRef.current.scrollHeight : 0);
    }
  }, [isExpanded]);

  return (
    <div
      style={{
        border: `4px solid ${club.borderColor}`,
        borderRadius: "10px",
        padding: "15px",
        backgroundColor: "#fff",
        minWidth: "280px",
        maxWidth: "320px",
        flex: "1 1 300px",
        display: "flex",
        flexDirection: "column",
        wordWrap: "break-word",
        transition: "all 0.3s ease",
        position: "relative",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ marginBottom: "10px", fontSize: "18px", flex: 1 }}>{club.name}</h3>
        <button
          style={{
            width: "52px",
            height: "52px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#808080",
            color: "#fff",
            cursor: "pointer",
            fontSize: "18px",
            fontWeight: "bold",
            textAlign: "center",
            lineHeight: "52px",
            transition: "all 0.2s ease",
          }}
          onClick={() => window.open(club.website || "#", "_blank")}
        >
          🔹
        </button>
      </div>

      <button
        style={{
          marginBottom: "10px",
          padding: "8px 12px",
          borderRadius: "5px",
          border: "none",
          backgroundColor: club.borderColor,
          color: "#fff",
          cursor: "pointer",
          fontSize: "14px",
        }}
        onClick={() => toggleExpand(club.id)}
      >
        {isExpanded ? "Hide Details" : "View Details"}
      </button>

      <div
        ref={contentRef}
        style={{
          overflow: "hidden",
          maxHeight: `${height}px`,
          transition: "max-height 0.5s ease",
          fontSize: "14px",
        }}
      >
        <p><strong>State:</strong> {club.state}</p>
        <p><strong>City:</strong> {club.city}</p>
        <p><strong>Location:</strong> {club.location}</p>
        <p><strong>Night:</strong> {club.night}</p>
        {club.caller_cuer && <p><strong>Caller/Cuer:</strong> {club.caller_cuer}</p>}
        <p><strong>Time:</strong> {club.time}</p>
        <p><strong>Level:</strong> {club.level}</p>
        <p><strong>Telephone:</strong> {club.telephone}</p>
        <p>
          <strong>Email:</strong>{" "}
          <a href={`mailto:${club.email}`}>{club.email}</a>
        </p>
        <p>
          <strong>Facebook:</strong>{" "}
          <a href={club.facebook} target="_blank" rel="noopener noreferrer">
            {club.facebook}
          </a>
        </p>
        <p>
          <strong>Website:</strong>{" "}
          <a href={club.website} target="_blank" rel="noopener noreferrer">
            {club.website}
          </a>
        </p>
      </div>
    </div>
  );
};

export default App;
